<template>
  <div>
    <select class="custom-select my-1 list-step-options-select" v-model="selectedValue" @change="handleOptionChange">
      <option value="">یک گزینه را انتخاب کنید</option>
      <option v-for="(option,index) in options" :value="index" :key="generateRandomString()">{{ index }}</option>
    </select>

    <step-options1 v-model="emitValue" :feature-selected-attribute="featureSelectedAttribute"
                   v-if="Object.keys(selectedValueOptions).length != 0" :level="newLevel"
                   :options="selectedValueOptions"/>
  </div>
</template>

<script>
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: 'StepOptions1',
  props: {
    options: {},
    level: {
      default: 0
    },
    featureSelectedAttribute: {
      default: ''
    }
  },
  data() {
    return {
      selectedValue: '',
      emitValue: []
    };
  },
  computed: {
    newLevel() {
      return this.level + 1
    },
    selectedValueOptions() {
      // Extract and split the selected value

      let result = {}
      for (const [key, item] of Object.entries(this.options)) {
        if (key == this.selectedValue) {
          item.forEach(value => {
            let options = value.value.split(':')
            const newKey = options[this.newLevel];
            if (Object.keys(result).indexOf(newKey) === -1 && newKey !== undefined) {
              result[newKey] = []
            }
            if (newKey !== undefined) {
              result[newKey].push(value)
            }

          })
        }
      }
      return result
    }
  },
  methods: {
    generateRandomString,
    handleOptionChange() {
      this.emitValue = this.selectedValue
    },
  },
  mounted() {
    if (this.featureSelectedAttribute != '') {
      this.selectedValue = this.featureSelectedAttribute.split(':')[this.level]
    }
  },
  watch: {
    emitValue: {
      handler(oldValue, newValue) {
        // add hash to value to make v-model catch data even if first and second value are the same
        // for example for cities if we send Hamedan and then select Hamedan v-model cant catch the different
        let temp = {
          value: this.emitValue,
          id: generateRandomString()
        }

        this.$emit('update:modelValue', temp)
      },
      deep: true
    }
  }
};
</script>
